/** Canonical order used when resolving a route that is absent from the current list. */
export const JOIN_STEPS_ORDER = [
  'date',
  'push',
  'email',
  'ready',
  'presentation',
  'fraternity',
  'gender',
  'place',
  'lead',
  'recap',
] as const

export type TJoinStep = (typeof JOIN_STEPS_ORDER)[number]

export type TJoinTerminal = 'congrats' | 'community'

export type TJoinDestination = TJoinStep | TJoinTerminal

export const FRATERNITY_QUESTION_STEPS = ['gender', 'place', 'lead', 'recap'] as const satisfies readonly TJoinStep[]

export type TFraternityQuestionStep = (typeof FRATERNITY_QUESTION_STEPS)[number]
